import { PracticeCreate } from '../pages/PracticeCreate';
import { PracticeFeedback } from '../pages/PracticeFeedback';
import { PracticeList } from '../pages/PracticeList';
import { PracticeRunning } from '../pages/PracticeRunning';
import PracticeEnemExam from '../pages/Enem/Exam';
import PracticeEnemFeedback from '../pages/Enem/Feedback';
import PracticeEnemList from '../pages/Enem/List';
import PracticeEnemDaySelection from '../pages/Enem/DaySelection';
import Template from '../../../core/templates/baseApp';
import { PracticeRevisionExercise } from '../pages/PracticeRevisionExercise';

export const PracticeRoutes = [
  {
    path: ':tab',
    element: (
      <Template>
        <PracticeList />
      </Template>
    ),
  },
  {
    path: 'revisao/:id',
    element: (
      <Template>
        <PracticeRevisionExercise />
      </Template>
    ),
  },
  {
    path: 'criar',
    element: (
      <Template>
        <PracticeCreate />
      </Template>
    ),
  },
  {
    path: 'simulado/:simuladoId',
    element: <PracticeRunning />,
  },
  {
    path: 'feedback/:simuladoId',
    element: (
      <Template>
        <PracticeFeedback />
      </Template>
    ),
  },
  {
    path: 'enem',
    element: (
      <Template>
        <PracticeEnemList />,
      </Template>
    ),
  },
  // Escolha entre 1º e 2º dia. Simulado de etapa única redireciona sozinho
  // para /prova, sem passar por esta tela.
  {
    path: 'enem/:slug',
    element: (
      <Template>
        <PracticeEnemDaySelection />
      </Template>
    ),
  },
  // Prova em tela cheia, sem menu — um por dia.
  {
    path: 'enem/:slug/dia/:day',
    element: <PracticeEnemExam />,
  },
  {
    path: 'enem/:slug/dia/:day/gabarito',
    element: (
      <Template>
        <PracticeEnemFeedback />
      </Template>
    ),
  },
  // Etapa única (simulados sem segundo dia configurado)
  {
    path: 'enem/:slug/prova',
    element: <PracticeEnemExam />,
  },
  {
    path: 'enem/:slug/gabarito',
    element: (
      <Template>
        <PracticeEnemFeedback />
      </Template>
    ),
  },
  // Rota antiga do gabarito: mantida para não quebrar links já compartilhados.
  {
    path: 'enem/:slug/feedback',
    element: (
      <Template>
        <PracticeEnemFeedback />
      </Template>
    ),
  },
];
